module.exports = __webpack_public_path__ + "images/category_lp/brand_samples/pattern_new2/sp/fv_ae66230b218b300da6ad7bc6a321f023.jpg";